import {
  CalendarIcon as CalendarIconOutline,
  UserIcon as UserIconOutline,
  BanknotesIcon as BanknotesIconOutline,
  Cog8ToothIcon as Cog8ToothIconOutline,
  ChatBubbleLeftIcon as ChatBubbleLeftIconOutline,
  EnvelopeIcon as EnvelopeIconOutline,
  NewspaperIcon as NewspaperIconOutline,
  GlobeAltIcon as GlobeAltIconOutline
  // CurrencyDollarIcon as CurrencyDollarIconOutline,
  // QuestionMarkCircleIcon as QuestionMarkCircleIconOutline
} from "@heroicons/react/24/outline"
import {
  CalendarIcon as CalendarIconSolid,
  UserIcon as UserIconSolid,
  BanknotesIcon as BanknotesIconSolid,
  Cog8ToothIcon as Cog8ToothIconSolid,
  ChatBubbleLeftIcon as ChatBubbleLeftIconSolid,
  EnvelopeIcon as EnvelopeIconSolid,
  NewspaperIcon as NewspaperIconSolid,
  // VideoCameraIcon as VideoCameraIconOutline,
  // VideoCameraIcon as VideoCameraIconSolid,
  GlobeAltIcon as GlobeAltIconSolid
  // CurrencyDollarIcon as CurrencyDollarIconSolid,
  // QuestionMarkCircleIcon as QuestionMarkCircleIconSolid
} from "@heroicons/react/24/solid"
import React from "react"

import { useFeatureFlags } from "../contexts/FeatureFlagContext"

const navItems = [
  {
    name: "Calendar",
    href: "/portal/calendar",
    solidIcon: <CalendarIconSolid className=" size-6 text-black" />,
    outlineIcon: <CalendarIconOutline className=" size-6 text-gray-dark" />
  },
  {
    name: "Clients",
    href: "/portal/clients",
    solidIcon: <UserIconSolid className=" size-6 text-black" />,
    outlineIcon: <UserIconOutline className=" size-6 text-gray-dark" />
  },
  {
    name: "Payments",
    href: "/portal/payments",
    solidIcon: <BanknotesIconSolid className=" size-6 text-black" />,
    outlineIcon: <BanknotesIconOutline className=" size-6 text-gray-dark" />
  },
  {
    name: "My Practice",
    href: "/portal/services",
    solidIcon: <NewspaperIconSolid className=" size-6 text-black" />,
    outlineIcon: <NewspaperIconOutline className=" size-6 text-gray-dark" />,
    children: [
      {
        name: "Services",
        href: "/portal/services",
        solidIcon: null,
        outlineIcon: null
      },
      {
        name: "Locations & Hours",
        href: "/portal/services/locations",
        solidIcon: null,
        outlineIcon: null
      },
      {
        name: "Details",
        href: "/portal/profile/combined",
        solidIcon: null,
        outlineIcon: null
      },
      {
        name: "Listing Card",
        href: "/portal/listing_card",
        solidIcon: null,
        outlineIcon: null
      },
      {
        name: "Credentials",
        href: "/portal/profile/credential",
        solidIcon: null,
        outlineIcon: null
      },
      {
        name: "Intake Form", // display name set in getSideNavigationItems from multipleIntakeFormsEnabled
        nameKey: "intake_form",
        href: "/portal/settings/intake_forms",
        solidIcon: null,
        outlineIcon: null
      },
      {
        name: "Keywords",
        href: "/portal/reviews/keywords",
        solidIcon: null,
        outlineIcon: null
      },
      {
        name: "Gift Cards",
        href: "/portal/gift_card_templates",
        solidIcon: null,
        outlineIcon: null
      }
    ]
  },
  {
    name: "My Website",
    href: "/portal/website/settings",
    solidIcon: <GlobeAltIconSolid className=" size-6 text-black" />,
    outlineIcon: <GlobeAltIconOutline className=" size-6 text-gray-dark" />,
    children: [
      {
        name: "Content",
        href: "/portal/website/builder",
        solidIcon: null,
        outlineIcon: null
      },
      {
        name: "Builder v2 (Beta)",
        href: "/portal/website_v2/builder",
        solidIcon: null,
        outlineIcon: null
      },
      {
        name: "Blog",
        href: "/portal/website/blog",
        solidIcon: null,
        outlineIcon: null
      },
      {
        name: "Settings",
        href: "/portal/website/settings",
        solidIcon: null,
        outlineIcon: null
      }
    ]
  },
  {
    name: "Reviews",
    href: "/portal/reviews/request",
    solidIcon: <ChatBubbleLeftIconSolid className=" size-6 text-black" />,
    outlineIcon: <ChatBubbleLeftIconOutline className=" size-6 text-gray-dark" />,
    children: [
      {
        name: "Request",
        href: "/portal/reviews/request",
        solidIcon: null,
        outlineIcon: null
      },
      {
        name: "Import",
        href: "/portal/reviews/import",
        solidIcon: null,
        outlineIcon: null
      },
      {
        name: "Video Reviews",
        href: "/portal/video_reviews",
        solidIcon: null,
        outlineIcon: null
      },
      {
        name: "Completed",
        href: "/portal/reviews/completed",
        solidIcon: null,
        outlineIcon: null
      },
      {
        name: "Pending",
        href: "/portal/reviews/pending",
        solidIcon: null,
        outlineIcon: null
      }
    ]
  },
  {
    name: "Newsletters",
    href: "/portal/settings/newsletter/campaigns",
    solidIcon: <EnvelopeIconSolid className=" size-6 text-black" />,
    outlineIcon: <EnvelopeIconOutline className=" size-6 text-gray-dark" />,
    children: [
      {
        name: "Campaigns",
        href: "/portal/settings/newsletter/campaigns",
        solidIcon: null,
        outlineIcon: null
      },
      {
        name: "Mailboxes",
        href: "/portal/settings/newsletter",
        solidIcon: null,
        outlineIcon: null
      }
    ]
  },
  {
    name: "Settings",
    href: "/portal/settings",
    solidIcon: <Cog8ToothIconSolid className=" size-6 text-black" />,
    outlineIcon: <Cog8ToothIconOutline className=" size-6 text-gray-dark" />,
    children: [
      {
        name: "Account",
        href: "/portal/settings/personal",
        solidIcon: null,
        outlineIcon: null
      },
      {
        name: "Calendar",
        href: "/portal/settings/calendar",
        solidIcon: null,
        outlineIcon: null
      },
      {
        name: "Video Conferencing",
        href: "/portal/settings/conferencing",
        solidIcon: null,
        outlineIcon: null
      },
      {
        name: "Payments",
        href: "/portal/settings/banking",
        solidIcon: null,
        outlineIcon: null
      },
      {
        name: "Communication",
        href: "/portal/settings/communication",
        solidIcon: null,
        outlineIcon: null
      },
      {
        name: "Booking",
        href: "/portal/settings/booking",
        solidIcon: null,
        outlineIcon: null
      },
      {
        name: "Subscription",
        href: "/portal/subscriptions",
        solidIcon: null,
        outlineIcon: null
      }
    ]
  }
  // {
  //   name: "Video Reviews",
  //   href: "/portal/video_reviews",
  //   solidIcon: <VideoCameraIconSolid className=" h-6 w-6 text-black" />,
  //   outlineIcon: <VideoCameraIconOutline className=" h-6 w-6 text-gray-dark" />,
  //   children: [
  //     {
  //       name: "List",
  //       href: "/portal/video_reviews",
  //       solidIcon: null,
  //       outlineIcon: null
  //     },
  //     {
  //       name: "Requests",
  //       href: "/portal/video_reviews/requests",
  //       solidIcon: null,
  //       outlineIcon: null
  //     }
  //   ]
  // },
  // {
  //   name: "Earn $79",
  //   href: "/portal/referral_program",
  //   solidIcon: <CurrencyDollarIconSolid className=" h-6 w-6 text-black" />,
  //   outlineIcon: <CurrencyDollarIconOutline className=" h-6 w-6 text-gray-dark" />
  // },
  // {
  //   name: "Help",
  //   href: "#",
  //   solidIcon: <QuestionMarkCircleIconSolid className="h-6 w-6 text-black" />,
  //   outlineIcon: <QuestionMarkCircleIconOutline className="h-6 w-6 text-gray-dark" />,
  //   id: "Intercom"
  // }
]

export function getSideNavigationItems({ websitePlan, usingBuilderV2, featureFlagOverrides }) {
  const ctx = useFeatureFlags()
  const merged = { ...ctx, ...(featureFlagOverrides || {}) }
  const {
    giftCardsEnabled,
    conferencingEnabled,
    videoReviewsEnabled,
    listingCardEnabled,
    blogEnabled,
    multipleIntakeFormsEnabled,
    practitionerNewslettersEnabled
  } = merged

  let navigationItems = [...navItems]

  navigationItems = !websitePlan ? navigationItems : navigationItems.filter((item) => item.name !== "My Website")

  // Filter top level navigation items
  navigationItems = navigationItems.filter((item) => {
    if (!videoReviewsEnabled && item.name === "Video Reviews") return false
    if (!practitionerNewslettersEnabled && item.name === "Newsletters") return false
    return true
  })

  // Filter and transform both top level and sub nav items for gift cards, video conferencing, and builder version
  navigationItems = navigationItems.map((item) => {
    if (item.children) {
      return {
        ...item,
        children: item.children
          .filter((child) => {
            if (!giftCardsEnabled && child.name === "Gift Cards") return false
            if (!conferencingEnabled && child.name === "Video Conferencing") return false
            if (!listingCardEnabled && child.name === "Listing Card") return false

            // Builder version logic: show only the Content option for the active builder version
            if (child.name === "Content" && usingBuilderV2) {
              // If using Builder v2, show only the v2 Content option
              return child.href === "/portal/website_v2/builder"
            } else if (child.name === "Content" && !usingBuilderV2) {
              // If using Builder v1, show only the v1 Content option
              return child.href === "/portal/website/builder"
            } else if (child.name === "Builder v2 (Beta)") {
              // Show "Builder v2 (Beta)" only if using v2, it will be transformed to "Content" in the map
              return usingBuilderV2
            } else if (child.name === "Blog") {
              return usingBuilderV2 && blogEnabled
            }

            return true
          })
          .map((child) => {
            // Transform "Builder v2 (Beta)" to "Content" if it passed the filter
            if (child.name === "Builder v2 (Beta)") {
              return {
                ...child,
                name: "Content",
                href: "/portal/website_v2/builder"
              }
            }
            // Pluralize nav label when multiple intake forms is enabled
            if (child.nameKey === "intake_form") {
              return { ...child, name: multipleIntakeFormsEnabled !== false ? "Intake Forms" : "Intake Form" }
            }
            return child
          })
      }
    }
    return item
  })

  return navigationItems
}
